/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import {
  DashboardOutlined,
  TeamOutlined,
  GlobalOutlined,
  ShoppingOutlined,
  UserOutlined,
  TransactionOutlined,
  GiftOutlined,
  SettingOutlined,
  DollarOutlined,
  ShoppingCartOutlined,
  OrderedListOutlined,
  FileTextOutlined,
  UploadOutlined,
  ImportOutlined,
  FlagOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import logo from "../../assets/images/logo.png";
import { useAuth } from "../../contexts/AuthContext";

function Sidenav({ color }) {
  const { user } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  // Définition des menus par rôle
  const adminMenuItems = [
    {
      key: "admin-dashboard",
      icon: <DashboardOutlined />,
      label: t('navigation.dashboard'),
      path: "/admin/dashboard"
    },
    {
      key: "admin-agencies",
      icon: <TeamOutlined />,
      label: t('navigation.agencies'),
      path: "/admin/agencies"
    },
    {
      key: "admin-areas",
      icon: <GlobalOutlined />,
      label: t('navigation.areas'),
      path: "/admin/areas"
    },
    {
      key: "admin-countries",
      icon: <FlagOutlined />,
      label: t('navigation.countries'),
      path: "/admin/countries"
    },
    {
      key: "admin-packs",
      icon: <ShoppingOutlined />,
      label: t('navigation.packs'),
      path: "/admin/packs"
    },
    {
      key: "admin-update-packs-prices",
      icon: <DollarOutlined />,
      label: t('admin.packs.packPrices'),
      path: "/admin/update-packs-prices"
    },
    {
      key: "admin-import-packs-prices",
      icon: <UploadOutlined />,
      label: t('navigation.importPacksPrices'),
      path: "/admin/import-packs-prices"
    },
    {
      key: "admin-subscribers",
      icon: <UserOutlined />,
      label: t('navigation.subscribers'),
      path: "/admin/subscribers"
    },
    {
      key: "admin-transactions",
      icon: <TransactionOutlined />,
      label: t('agency.payments.title'),
      path: "/admin/transactions"
    },
    {
      key: "admin-vouchers",
      icon: <GiftOutlined />,
      label: t('navigation.vouchers'),
      path: "/admin/vouchers"
    },
    {
      key: "admin-manual-payments",
      icon: <DollarOutlined />,
      label: t('navigation.manualPayments'),
      path: "/admin/manual-payments"
    },
    {
      key: "admin-import-esim-inventory",
      icon: <ImportOutlined />,
      label: t('navigation.importEsimInventory', 'Import Inventaire eSIM'),
      path: "/admin/import-esim-inventory"
    }
  ];

  const agencyMenuItems = [
    {
      key: "agency-dashboard",
      icon: <DashboardOutlined />,
      label: t('agency.dashboard.myDashboard'),
      path: "/agency/dashboard"
    },
    {
      key: "agency-vouchers",
      icon: <GiftOutlined />,
      label: t('agency.vouchers.title'),
      path: "/agency/vouchers"
    },
    
    {
      key: "agency-packs",
      icon: <ShoppingOutlined />,
      label: t('agency.packs.packStore'),
      path: "/agency/packs"
    },
    {
      key: "agency-cart",
      icon: <ShoppingCartOutlined />,
      label: t('agency.cart.myCart'),
      path: "/agency/cart"
    },
    {
      key: "agency-orders",
      icon: <OrderedListOutlined />,
      label: t('agency.orders.myOrders'),
      path: "/agency/orders"
    },
    {
      key: "agency-manual-payment",
      icon: <DollarOutlined />,
      label: t('navigation.manualPayments'),
      path: "/agency/manual-payment"
    },

     {
      key: "agency-demand-payment",
      icon: <DollarOutlined />,
      label: t('navigation.demandPayments'),
      path: "/agency/demand-payment"
    },

    {
      key: "agency-invoice-history",
      icon: <FileTextOutlined />,
      label: t('agency.invoices.title'),
      path: "/agency/invoice-history"
    }
  ];

  // Sélectionner le menu en fonction du rôle de l'utilisateur
  let menuItems = agencyMenuItems; // Par défaut, menu agence
  
  if (user && user.authorities) {
    if (user.authorities.includes('ROLE_ADMIN')) {
      menuItems = adminMenuItems;
    }
  }

  return (
    <>
      <div className="brand">
        <img src={logo} alt="Castrum eSIM Dashboard" />
        <span>Pro</span>
      </div>
      <hr />
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={[location.pathname]}
      >
        {menuItems.map(item => (
          <Menu.Item key={item.path} icon={item.icon}>
            <NavLink to={item.path}>
              <span className="label">{item.label}</span>
            </NavLink>
          </Menu.Item>
        ))}
        <Menu.Item key="/profile" icon={<SettingOutlined />}>
          <NavLink to="/profile">
            <span className="label">{t('common.profile')}</span>
          </NavLink>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default Sidenav;
